module.exports = __webpack_public_path__ + "fonts/8feb512.woff";